__turbopack_context__.v({
  "headerCloseButton": "CartHeader-module-scss-module__YsVwWG__headerCloseButton",
  "headerContainer": "CartHeader-module-scss-module__YsVwWG__headerContainer",
  "headerInformation": "CartHeader-module-scss-module__YsVwWG__headerInformation",
  "headerInformationTags": "CartHeader-module-scss-module__YsVwWG__headerInformationTags",
  "headerInnerContainer": "CartHeader-module-scss-module__YsVwWG__headerInnerContainer",
  "headerTop": "CartHeader-module-scss-module__YsVwWG__headerTop",
  "headerTopActions": "CartHeader-module-scss-module__YsVwWG__headerTopActions",
  "headerTopLoader": "CartHeader-module-scss-module__YsVwWG__headerTopLoader",
  "headerTopTitle": "CartHeader-module-scss-module__YsVwWG__headerTopTitle",
  "middot": "CartHeader-module-scss-module__YsVwWG__middot",
  "orderFormat": "CartHeader-module-scss-module__YsVwWG__orderFormat",
  "serviceTime": "CartHeader-module-scss-module__YsVwWG__serviceTime",
});
